const SubscriptionTerm = {
  MONTHLY: 'P1M',
  ANNUAL: 'P1Y',
} as const;

export default SubscriptionTerm;
